var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteprem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6685 38.1491C22.0132 39.4128 18.0618 39.4528 14.3829 38.2634C10.704 37.074 7.48725 34.7165 5.1955 31.53C2.90374 28.3435 1.65513 24.4923 1.62931 20.5307C1.6035 16.569 2.80181 12.701 5.05182 9.48331C7.30184 6.26559 10.4876 3.864 14.1506 2.6241C17.8137 1.3842 21.7652 1.3699 25.4367 2.58327C29.1082 3.79664 32.3103 6.17511 34.5823 9.37647C36.8544 12.5778 38.0792 16.437 38.0805 20.3988C38.0216 21.9174 37.8426 23.4285 37.5453 24.9173",
    stroke: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1517 34.6699C22.8405 36.2001 21.4031 37.6112 19.8555 38.8872",
    stroke: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8555 1.45898C24.7752 5.87427 27.8194 12.0905 28.3379 18.78C28.4443 19.9943 28.4664 21.2149 28.4039 22.4325",
    stroke: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8555 1.45898C17.1863 3.84889 15.0418 6.79415 13.5643 10.0996C12.0868 13.4051 11.3099 16.9954 11.2852 20.6326C11.2852 32.8326 16.6224 36.4474 19.8335 38.8874",
    stroke: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 11.1738H35.7996",
    stroke: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8555 1.45117V38.8871",
    stroke: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 30.4375H23.5503",
    stroke: "inherit"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62891 20.6332L38.0805 20.1738",
    stroke: "inherit"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6683 39.1132L38.9161 35.7695L33.051 29.7448L36.3867 27.5533C36.4354 27.5238 36.4741 27.4798 36.4978 27.4272C36.5215 27.3746 36.5291 27.3158 36.5196 27.2586C36.5101 27.2015 36.4838 27.1486 36.4444 27.1071C36.405 27.0656 36.3542 27.0374 36.2988 27.0262L25.0891 24.3301C25.0428 24.3204 24.9949 24.3227 24.9497 24.3367C24.9044 24.3507 24.8632 24.3759 24.8298 24.4102C24.7964 24.4446 24.7718 24.4868 24.7582 24.5333C24.7446 24.5798 24.7424 24.629 24.7518 24.6766L27.1859 36.4096C27.1976 36.4667 27.2255 36.5189 27.2662 36.5595C27.3068 36.6002 27.3583 36.6275 27.4142 36.638C27.47 36.6485 27.5276 36.6417 27.5796 36.6185C27.6316 36.5952 27.6758 36.5566 27.7064 36.5076L29.8032 33.0885L35.6683 39.1132Z",
    stroke: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteprem);
export default __webpack_public_path__ + "static/media/websiteprem.6b544eb9452a434820e7c511d2c99010.svg";
export { ForwardRef as ReactComponent };